export * from "modules/DealerDetails/hooks/useDealerDetailsQuery";
export * from "modules/DealerDetails/hooks/useUpdateDealerMutation";
